import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-title" }
const _hoisted_2 = { class: "color-input" }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorPicker = _resolveComponent("ColorPicker", true)!

  return (_openBlock(), _createElementBlock("div", {
    onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    class: "color-picker animated-fast"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.colorPicker`)) + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textInputHexColorUppercase) = $event))
        }, null, 512), [
          [_vModelText, _ctx.textInputHexColorUppercase]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ColorPicker, {
        ref: "vue-color",
        theme: "light",
        color: _ctx.tempColor,
        "sucker-hide": true,
        onChangeColor: _ctx.changeColor,
        colorsDefault: [
					'#000000',
					'#FFFFFF',
					'#FF1900',
					'#F47365',
					'#FFB243',
					'#FFE623',
					'#6EFF2A',
					'#1BC7B1',
					'#00BEFF',
					'#2E81FF',
					'#5D61FF',
					'#FF89CF',
					'#FC3CAD',
					'#BF3DCE',
					'#8E00A7'
				]
      }, null, 8, ["color", "onChangeColor"])
    ])
  ], 32))
}